<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }} alert-dismissable alert fixed-bottom">
  {{alert.message}}
  <a class="close" (click)="removeAlert(alert)"><ng-container i18n="@@alert.close">Stäng</ng-container><span class="close-x">&times;</span></a>
</div>
